.taskPageDropZone {
    margin: 0 !important;
    padding: 0 !important;
    width: 100%;
    height: 100%;
}
